const configMember = {
    homeMember: {
        listLayout: 'MemberListHomeLayout',
        getFunc: 'getMember',
        listApiParamSet: {
            opf: 1,
            di:1,
            al:1
        },
    },
    mentor: {
        listLayout: 'MemberListDefaultLayout',
        getFunc: 'getMember',
        filterLayout: 'MemberFilterDefaultLayout',
        listApiParamSet: {
            ip: 1,
            sp: 1,
            opf: 1,
            // di:1,
            al:1
        },
        paginationLayout: 'PaginationDefaultLayout',
        pageRow: 10,
    }

}
export default {
    methods: {
        returnMemberConfig(type) {
            return configMember[type];
        }
    },
    filterConfig: {
        ac: {
            type: 'match',
            classname: 'filterSi',
        },
    }
}
